// src/modules/LiberaProximaVenda/DocumentGrid.jsx
import React, { useState } from 'react';
import './DocumentGrid.css';
import { formatarData } from '../../utils/formatarDataHora';
import { releaseNextSale } from './services/documentService';
import { useAuth } from '../../context/AuthContext';

const DocumentGrid = ({ documents, documentType, onRelease }) => {
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [isReleasing, setIsReleasing] = useState(false);
  const { user } = useAuth();

  const handleSelect = (doc) => {
    setSelectedDocument(doc);
  };

  const handleRelease = async () => {
    if (!selectedDocument) {
      window.showAlert('danger', 'Please select a document to release.');
      return;
    }

    try {
      setIsReleasing(true);
      
      const result = await releaseNextSale(
        selectedDocument.FILIAL,
        selectedDocument.NUMDOC,
        selectedDocument.CLIENTE,
        selectedDocument.LOJA,
        user.userName, 
        documentType.type
      );

      window.showAlert('success', 'Documento liberado com sucesso!');
      console.log('Documento liberado com sucesso!');
      console.log('Release result:', result);

      if (onRelease) {
        onRelease(result);
      }
    } catch (error) {
      console.error('Error releasing document:', error);
      window.showAlert('danger', 'Erro liberando documento, tente novamente. Se o problema persistir, contate o suporte.');
    } finally {
      setIsReleasing(false);
    }
  };

  // if (!documents || documents.length === 0) {
  //   return (
  //     <div className="document-grid-container">
  //       <div className="alert alert-info" role="alert">
  //         {/* Nenhum documento encontrado. */}
  //       </div>
  //     </div>
  //   );
  // }

  return (
    <div className="document-grid-container">
      <h6 className="mb-3">Documentos Encontrados: {documents.length}</h6>

      <div className="documents-list">
        {documents.map((doc, index) => (
          <div
            key={`${doc.FILIAL}-${doc.NUMDOC}-${index}`}
            className={`document-card ${selectedDocument === doc ? 'selected' : ''}`}
            onClick={() => handleSelect(doc)}
          >
            <div className="document-card-content">
              <div className="card-radio">
                <input
                  type="radio"
                  name="selectedDocument"
                  checked={selectedDocument === doc}
                  onChange={() => handleSelect(doc)}
                  onClick={(e) => e.stopPropagation()}
                />
              </div>
              <div className="card-info">
                <div className="card-first-line">
                  {doc.CLIENTE} - {doc.LOJA} - {doc.NOME}
                </div>
                <div className="card-second-line">
                  <span className="card-date">{formatarData(`${doc.DATA} - 000000`)}</span>
                  <span className="card-numdoc">{doc.NUMDOC}</span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="row mt-3">
        <div className="col-12">
          <button
            className="btn btn-success w-100"
            onClick={handleRelease}
            disabled={!selectedDocument || isReleasing}
          >
            {isReleasing ? 'Liberando...' : 'Liberar'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DocumentGrid;
